export const LoaderSize = {
  DEFAULT_SIZE: 72,
  MEDIUM: 48,
  SMALL: 24
};

export const INT_MAX = 2_147_483_647;
export const DEFAULT_ROWS_PER_PAGE = 10;
export const DEFAULT_ROWS_PER_PAGE_MIDDLE = 25;
export const DEFAULT_ROWS_PER_PAGE_MAX = 50;
export const DEFAULT_ROWS_PAGE_OPTIONS = [10, 25, 50, 100];
export const DEFAULT_ROWS_PAGE_BIG_OPTIONS = [10, 25, 50, 100, 250];
